import { authenticatedGet, authenticatedPost } from '../utils/apiUtils';
import { FEE_CONFIG_URL } from '../api-config';

/**
 * Read the active platform-fee composition.
 *
 * Returns the backend shape:
 *   { fixed_fee_cents, percent_bps, percent, updated_at, updated_by, source }
 *
 * `source` is "db" when the value comes from the persisted config row, or
 * "default" when the backend synthesised it from env vars / code defaults.
 */
export const getFeeConfig = () => authenticatedGet(FEE_CONFIG_URL);

/**
 * Persist a new platform-fee composition. Applies to every NEW pledge;
 * existing pledges keep the fee snapshot stored at creation time.
 *
 * @param {number} fixedFeeCents - Flat fee component, in cents (non-negative int).
 * @param {number} percentBps - Percentage component, in basis points (300 = 3.00%).
 */
export const updateFeeConfig = (fixedFeeCents, percentBps) =>
  authenticatedPost(FEE_CONFIG_URL, {
    fixed_fee_cents: fixedFeeCents,
    percent_bps: percentBps,
  });
